"use strict";

PF.Field.DateDiapasonWithPreset = class DateDiapasonWithPreset extends PF.Field
	{
	static get options()
		{
		return {
			presetConfig: {
				dom: {
					element: undefined
				},
				silentSetData: true,
				listConfig: {
					modelsConfig: {
						raw: [
							{
								id: 'day',
								name: "Сегодня",
								diapason: () => {
									return {
										start: DateTime.local().startOf('day'),
										finish: DateTime.local().endOf('day'),
									};
								},
								discrete: () => {
									return {
										id: 'hour',
										name: "Часам"
									};
								}
							},
							{
								id: 'yesterday',
								name: "Вчера",
								diapason: () => {
									return {
										start: DateTime.local().minus({days: 1}).startOf('day'),
										finish: DateTime.local().minus({days: 1}).endOf('day'),
									};
								},
								discrete: () => {
									return {
										id: 'hour',
										name: "Часам"
									};
								}
							},
							{
								id: 'week',
								name: "Неделя",
								diapason: () => {
									return {
										start: DateTime.local().minus({days: 7}).startOf('day'),
										finish: DateTime.local().endOf('day'),
									};
								},
								discrete: () => {
									return {
										id: 'day',
										name: "Суткам"
									};
								}
							},
							{
								id: 'month',
								name: "Месяц",
								diapason: () => {
									return {
										start: DateTime.local().minus({days: 30}).startOf('day'),
										finish: DateTime.local().endOf('day'),
									};
								},
								discrete: () => {
									return {
										id: 'day',
										name: "Суткам"
									};
								}
							},
							{
								id: '3month',
								name: "3 месяца",
								diapason: () => {
									return {
										start: DateTime.local().minus({month: 3}).startOf('day'),
										finish: DateTime.local().endOf('day'),
									};
								},
								discrete: () => {
									return {
										id: 'week',
										name: "Неделям"
									};
								}
							}
						]
					}
				},
				selectFirst: false,
				key: 'diapason',
			},
			datesConfig: {
				dom: {
					element: undefined
				},
				label: 'Или выберите диапазон дат:',
				startKey: 'calendar.start',
				finishKey: 'calendar.finish',
			},
			form: {},
		};
		}

	static get templates()
		{
		//language=HTML
		return `
		  <div pf="dateDiapasonWith">
			  <div class="block-header">Диапазон</div>
			  <div pf="preset"></div>
			  <input pf="calendar"/>
		  </div>
		`;
		}


	init()
		{
		super.init();

		this.preset = new PF.Field.ButtonsToggle({...this.presetConfig, model: this.model});
		this.dates = new PF.Field.DateDiapason({...this.datesConfig, model: this.model});

		this.model.onChange(this.presetConfig.key, () => {
			if (typeof this.model.get(this.presetConfig.key + '.diapason') === 'function')
				{
				let diapason = this.model.get(this.presetConfig.key + '.diapason')();
				let hasChange = false;
				if (this.model.get(this.datesConfig.startKey) !== Util.toDbDate(diapason.start))
					{
					this.model.setData(this.datesConfig.startKey, Util.toDbDate(diapason.start), true);
					hasChange = true;
					}
				if (this.model.get(this.datesConfig.finishKey) !== Util.toDbDate(diapason.finish))
					{
					this.model.setData(this.datesConfig.finishKey, Util.toDbDate(diapason.finish), true);
					hasChange = true;
					}
				if (hasChange)
					{
					this.model.trigger('changed');
					}
				}
		}, true);

		// this.model.onChange([this.calendar.startKey, this.calendar.finishKey], () => {
		// 	this.model.setData(this.preset, null, true);
		// });


		this.model.onChange([this.datesConfig.startKey, this.datesConfig.finishKey], () => {
			let currentDiapason = this.preset.nullItem.model;
			for (let i = 0; i < this.preset.list.models.length; i++)
				{
				let diapason = this.preset.list.models[i].diapason();
				// let diapason = this.form.get(`fields.preset.list.models.${i}.diapason`)();
				if (Util.toDbDate(diapason.start) === this.model.get(this.datesConfig.startKey) &&
					Util.toDbDate(diapason.finish) === this.model.get(this.datesConfig.finishKey))
					{
					currentDiapason = this.preset.list.models[i];
					break;
					}
				}
			this.model.setData(this.presetConfig.key, new PF.Model({raw: currentDiapason.toJSON()}), true);
		});


		// this.model.on('loaded', () => {
		// 	let start = this.model.data.calendar.start;
		// 	let finish = this.model.data.calendar.finish;
		// 	if (start !== null && finish === null)
		// 		{
		// 		this.model.data.calendar.start = null;
		// 		}
		// 	this.loadPlots();
		// });


		}
	};